/* VitaFresh Kollektion und Suche ohne Globo (sections/vf-kollektion.liquid, sections/main-search.liquid), Pasci 10.10.2026.
   Das Formular (snippets/vf-kollektion-filter.liquid) ist die einzige Quelle der URL-Parameter: Kästchen, Grössen-Pillen,
   Preisfelder, Sortierung. Jede Änderung wird gebündelt (WARTEZEIT_MS, letzter Aufruf gewinnt, keiner geht verloren),
   dann holt fetch nur diese Section (Section Rendering API: ?section_id=…&filter…), und die Teile werden getauscht:
   Raster, Zähler, Chips, Pillen und jede Filtergruppe ausser der gerade bedienten (dort nur Zähler und Balken).
   URL per pushState, Zurück-Taste per popstate. Fehler: alter Stand bleibt, Hinweis erscheint.
   Nährwert-Schieber: zwei Regler über den Indexen der vorhandenen Stufen; sie setzen nur die Kästchen der Stufen.
   Panels: Drawer «Alle Filter» (Desktop von rechts, Handy von unten) und Nährwert-Feld (Desktop unter der Pille,
   Handy von unten); Esc, Hintergrund, Fokus zurück, nur eines offen.
   Genussempfehlung: «Kalt»/«Warm» nehmen «Warm oder Kalt» mit (data-vfko-mit): das mitgewählte Kästchen steht angehakt
   und gesperrt, der Wert geht trotzdem in den Request; der Chip von «Kalt» entfernt ihn mit (data-vfko-ohne-*).
   Ansicht Raster/Liste: data-ansicht am <vf-kollektion>, Wahl in localStorage «vfko-ansicht» (das Inline-Skript der
   Section setzt sie vor dem ersten Zeichnen, damit nichts springt).
   Lupe (nur Kollektion): öffnet unter der Zeile das Suchfeld. Seit 30.10.2026 (Pasci) sucht es nur in dieser Kollektion,
   auf dieser Seite, über alle Gerichte und mit den aktiven Filtern (suchen, trefferZeigen; Begriff als ?q= per pushState);
   «Im ganzen Sortiment suchen» führt zur Suchseite. Mit der Abschnitts-Einstellung «such_filter» baut das Formular dafür
   seine Filter-Felder aus dem Filter-Formular (auch eben angetippte Werte, die noch laden oder deren Laden scheiterte),
   Grösse als roher Wert und Gruppe (Test R4 M1). Ohne Skript öffnet das Formular die Suchseite.
   Suchseite (Test R4): Grössen-Pillen schicken ihre Begleitwerte mit (data-vfko-auch: Gruppe, Saucen-Werte); aktive
   Filter aus der Adresse, die die Suche nicht anbietet, stehen als Chip und Feld da (data-vfko-fremd); eine unbekannte
   Sortierung aus alten Links lädt einmal mit dem Standard nach; der Chip «Sortiert: …» setzt den Standard.
   Abläufe (Prüfrunde 1 und 2): Jeder Ladevorgang bricht geplante Aufrufe und ein laufendes «Mehr laden» ab, eine alte
   Seite hängt nie an einem neuen Ergebnis. Die bediente Gruppe wird beim Planen festgehalten und mitgegeben. Fokus geht
   nach dem Nachladen nie verloren (dasselbe Feld, im offenen Panel nie dahinter, Chip → nächster Chip, sonst «Alle
   Filter»). Zurück-Taste lädt nur, wenn sich die Suche geändert hat (Anker-Links wie #main laden nichts). Am Handy setzt
   ein Wisch über einen Schieber keinen Filter: Touch und Stift bewegen den Daumen erst nach einer waagrechten Bewegung,
   reines Tippen springt beim Loslassen.
   Reine Logik (stufenIndexe, aktiveStufen, reglerKorrigieren, bereichText, parameterString, paareErgaenzen, mitZiele,
   mitFehlt, ohneParameter, sectionUrl, neuNachSchluessel, fokusIndex, fokusZiel, gruppeBehalten, sucheGeaendert,
   spurIndex, naechsterRegler, zeigerGeste, paareAusSuche, suchPaare, auchWerte, fremdeFilter, fremdName, sortUnbekannt,
   platzhalterAnzahl, seiteAus, mehrSchluessel, wiederherstellenBis, suchNormal, suchWoerter, passtSuche, suchTreffer,
   trefferSeiten, begriffAus, ohneBegriff, mitBegriff, trefferText) ist DOM-frei und in Node testbar: node --test tests/vf-kollektion.test.js.
   «Mehr laden» (18.10.2026): Knopf statt Link, sobald das Skript läuft (Shopify lädt Links sonst beim Antippen per
   Speculation Rules zusätzlich als ganze Seite vor), Platzhalter-Karten sofort beim Tippen (nichts springt, wenn die
   Antwort kommt), angehängte Fotos ohne Vorrang und lazy, Stand je Adresse in sessionStorage: Zurück ohne
   Back/Forward-Cache oder Neu laden holt die Seiten wieder und scrollt zur gemerkten Karte.
   Die Abläufe im Browser prüft tests/vf-browser.test.js (Playwright, überspringt sich ohne). */
(function (root) {
  "use strict";

  var WARTEZEIT_MS = 300;        /* Kästchen, Sortierung, Preis: Aufrufe bündeln */
  var WARTEZEIT_REGLER_MS = 450; /* Schieber: erst nach kurzem Innehalten laden */
  var ZIEH_SCHWELLE_PX = 6;      /* Touch/Stift: so weit waagrecht, bevor der Daumen folgt (sonst ist es Scrollen) */

  /* ---------- reine Logik ---------- */

  /* Regler-Stellung aus den aktiven Stufen: [von, bis] als Indexe (bis exklusiv). Keine Auswahl = ganzer Bereich. */
  function stufenIndexe(stufen, aktive) {
    var n = stufen.length;
    var von = -1, bis = -1;
    (aktive || []).forEach(function (a) {
      var i = stufen.indexOf(Number(a));
      if (i === -1) return;
      if (von === -1 || i < von) von = i;
      if (i + 1 > bis) bis = i + 1;
    });
    if (von === -1) return [0, n];
    return [von, bis];
  }

  /* Welche Stufen bei Regler-Stellung [von, bis) gewählt sind; ganzer Bereich = kein Filter (leer). */
  function aktiveStufen(stufen, von, bis) {
    if (von <= 0 && bis >= stufen.length) return [];
    return stufen.slice(Math.max(0, von), Math.min(stufen.length, bis));
  }

  /* Regler dürfen sich nicht kreuzen; mindestens eine Stufe bleibt gewählt. bewegt = 'von' | 'bis'. */
  function reglerKorrigieren(von, bis, n, bewegt) {
    von = Math.max(0, Math.min(n - 1, Math.round(Number(von) || 0)));
    bis = Math.max(1, Math.min(n, Math.round(Number(bis) || 0)));
    if (von >= bis) {
      if (bewegt === "von") von = bis - 1; else bis = von + 1;
    }
    return [von, bis];
  }

  /* Text zur Stellung: «alle», «bis 549 kcal», «ab 300 kcal», «300–549 kcal». Obergrenze = letzte Stufe + Schritt − 1. */
  function bereichText(stufen, von, bis, schritt, einheit) {
    var n = stufen.length;
    if (!n || (von <= 0 && bis >= n)) return "alle";
    var unten = stufen[von];
    var oben = stufen[bis - 1] + schritt - 1;
    if (von <= 0) return "bis " + oben + " " + einheit;
    if (bis >= n) return "ab " + unten + " " + einheit;
    return unten + "–" + oben + " " + einheit;
  }

  /* Formular-Paare zu Parametern: leere Werte, «page» und Standardwerte (standard = { sort_by: "best-selling" }) fallen
     weg, damit dieselbe Auswahl immer dieselbe URL hat. Reihenfolge bleibt. */
  function parameterString(paare, standard) {
    var p = [];
    standard = standard || {};
    (paare || []).forEach(function (paar) {
      var name = paar[0], wert = paar[1] == null ? "" : String(paar[1]);
      if (!name || name === "page" || name === "section_id" || wert.trim() === "") return;
      if (standard[name] && standard[name] === wert) return;
      p.push(encodeURIComponent(name) + "=" + encodeURIComponent(wert));
    });
    return p.join("&");
  }

  /* Mitgenommene Werte (z. B. «Warm oder Kalt» bei «Kalt») ergänzen, ohne Doppel. extras = [[name, wert], …] */
  function paareErgaenzen(paare, extras) {
    var aus = (paare || []).slice();
    (extras || []).forEach(function (e) {
      if (!e || !e[0] || e[1] == null || String(e[1]) === "") return;
      var da = aus.some(function (p) { return p[0] === e[0] && String(p[1]) === String(e[1]); });
      if (!da) aus.push([e[0], String(e[1])]);
    });
    return aus;
  }

  /* Welche Werte mitgewählt sind: eintraege = [{ angehakt, mit }] (mit = mitgenommener Wert oder leer). */
  function mitZiele(eintraege) {
    var ziele = [];
    (eintraege || []).forEach(function (e) {
      if (e && e.angehakt && e.mit && ziele.indexOf(e.mit) === -1) ziele.push(e.mit);
    });
    return ziele;
  }

  /* Fehlt ein mitgenommener Wert, obwohl seine Quelle angehakt ist (Direktlink nur mit «Kalt»)? eintraege = [{ wert,
     angehakt, mit }]. Dann zeigt die Seite weniger, als der nächste Klick verlangt: einmal nachziehen. */
  function mitFehlt(eintraege) {
    return mitZiele(eintraege).some(function (ziel) {
      return !(eintraege || []).some(function (e) { return e && e.wert === ziel && e.angehakt; });
    });
  }

  /* Ein Paar name=wert aus einer Suchzeile entfernen (Chip «Kalt» nimmt «Warm oder Kalt» mit), Rest bleibt. */
  function ohneParameter(suche, name, wert) {
    var teile = String(suche || "").replace(/^\?/, "").split("&").filter(Boolean);
    var rest = teile.filter(function (t) {
      var i = t.indexOf("=");
      var n, w;
      try {
        n = decodeURIComponent((i === -1 ? t : t.slice(0, i)).replace(/\+/g, " "));
        w = i === -1 ? "" : decodeURIComponent(t.slice(i + 1).replace(/\+/g, " "));
      } catch (e) { return true; }
      return !(n === name && w === String(wert));
    });
    return rest.join("&");
  }

  /* Adresse für die Section Rendering API. suche ohne «?». */
  function sectionUrl(pfad, suche, sectionId) {
    var s = (suche || "").replace(/^\?/, "");
    return pfad + "?" + (s ? s + "&" : "") + "section_id=" + encodeURIComponent(sectionId);
  }

  /* «Mehr laden»: welche Einträge der neuen Seite angehängt werden (true) und welche schon dastehen (false, gleicher
     Schlüssel = Handle bzw. Link). Verschiebt sich die Reihenfolge zwischen zwei Abrufen, gibt es so keine Dubletten. */
  function neuNachSchluessel(vorhanden, neu) {
    var da = {};
    (vorhanden || []).forEach(function (k) { if (k) da[k] = true; });
    return (neu || []).map(function (k) {
      if (!k) return true;
      if (da[k]) return false;
      da[k] = true;
      return true;
    });
  }

  /* Fokus nach dem Entfernen eines Chips: Chip an derselben Stelle, sonst der letzte; -1 = keiner (dann «Alle Filter»). */
  function fokusIndex(index, anzahl) {
    if (index == null || index < 0 || !(anzahl > 0)) return -1;
    return Math.min(index, anzahl - 1);
  }

  /* Wohin der Fokus geht, wenn das fokussierte Element beim Einsetzen ersetzt wurde: o = { gleich (dasselbe Feld ist
     wieder da und erreichbar), panel (Drawer oder Feld offen), chip (Index des entfernten Chips), chips (Anzahl jetzt) }.
     Bei offenem Panel nie auf eine Pille dahinter (aria-modal). */
  function fokusZiel(o) {
    o = o || {};
    if (o.gleich) return { art: "gleich" };
    if (o.panel) return { art: "panel" };
    var i = fokusIndex(o.chip, o.chips);
    return i >= 0 ? { art: "chip", index: i } : { art: "pille" };
  }

  /* Behält eine Filtergruppe beim Einsetzen ihre Felder? Nur die beim Planen bediente (Fokus, Regler, «Alle anzeigen»). */
  function gruppeBehalten(gruppe, key) {
    return !!gruppe && gruppe === key;
  }

  /* Zurück-/Vor-Taste: nur nachladen, wenn sich die Suche geändert hat (popstate kommt auch bei Anker-Links wie #main). */
  function sucheGeaendert(alt, neu) {
    return String(alt || "").replace(/^\?/, "") !== String(neu || "").replace(/^\?/, "");
  }

  /* Zeiger auf der Schieber-Spur als Stufen-Index (Kommazahl, 0…n). Die Daumen-Mitten liegen auf den Spur-Enden. */
  function spurIndex(x, links, breite, n) {
    if (!(breite > 0)) return 0;
    return Math.max(0, Math.min(n, (x - links) / breite * n));
  }

  /* Welcher Daumen den Zeiger übernimmt: der nähere (genau dazwischen «von»). So bleibt «von» auch ganz rechts greifbar. */
  function naechsterRegler(pos, von, bis) {
    return pos - von <= bis - pos ? "von" : "bis";
  }

  /* Touch/Stift auf der Spur: «ziehen», sobald die Bewegung waagrecht über die Schwelle geht, «scrollen», sobald sie
     senkrecht darüber geht, sonst noch offen (""). */
  function zeigerGeste(dx, dy, schwelle) {
    var ax = Math.abs(Number(dx) || 0), ay = Math.abs(Number(dy) || 0);
    if (ax > schwelle && ax > ay) return "ziehen";
    if (ay > schwelle && ay >= ax) return "scrollen";
    return "";
  }

  /* ---------- Test R4 (11.10.2026): Lupe und Suche ---------- */

  /* Suchzeile in Paare [name, wert] (dekodiert, «+» = Leerzeichen); kaputt kodierte Paare fallen weg. */
  function paareAusSuche(suche) {
    var aus = [];
    String(suche || "").replace(/^\?/, "").split("&").forEach(function (t) {
      if (!t) return;
      var i = t.indexOf("=");
      try {
        aus.push([decodeURIComponent((i === -1 ? t : t.slice(0, i)).replace(/\+/g, " ")), i === -1 ? "" : decodeURIComponent(t.slice(i + 1).replace(/\+/g, " "))]);
      } catch (e) { /* kaputt kodiert: weglassen */ }
    });
    return aus;
  }

  /* Felder der Lupe (Suche aus der Kollektion) aus den Formular-Paaren: nur Filter, ohne Sortierung, Seite, Begriff und
     type, ohne leere Werte; dazu Extras (mitgenommene Werte, roher Grössenname) ohne Doppel. */
  function suchPaare(paare, extras) {
    var weg = { sort_by: 1, page: 1, q: 1, type: 1, "options[prefix]": 1, section_id: 1 };
    var rein = (paare || []).filter(function (p) { return p && p[0] && !weg[p[0]] && p[1] != null && String(p[1]).trim() !== ""; });
    return paareErgaenzen(rein, extras);
  }

  /* Begleitwerte einer Grössen-Pille der Suche (data-vfko-auch = JSON-Liste: Gruppe und weitere rohe Werte) */
  function auchWerte(text) {
    var liste;
    try { liste = JSON.parse(text || "[]"); } catch (e) { return []; }
    if (!Array.isArray(liste)) return [];
    return liste.filter(function (w) { return w != null && String(w) !== ""; }).map(String);
  }

  /* Filter aus der Adresse, die das Formular nicht kennt (Suche bietet z. B. Ernährung nicht an, wendet sie aber an).
     bekannt = [[name, wert]] der Formularfelder, wert null = jeder Wert (Preisfelder). Jeder fremde Wert einmal. */
  function fremdeFilter(paare, bekannt) {
    var aus = [];
    (paare || []).forEach(function (p) {
      if (!p || String(p[0]).indexOf("filter.") !== 0 || String(p[1]).trim() === "") return;
      var da = (bekannt || []).some(function (b) { return b[0] === p[0] && (b[1] == null || String(b[1]) === String(p[1])); });
      var doppelt = aus.some(function (a) { return a[0] === p[0] && a[1] === p[1]; });
      if (!da && !doppelt) aus.push([p[0], String(p[1])]);
    });
    return aus;
  }

  /* Text des Chips für einen fremden Filter: «Ernährung: Vegan»; Metaobjekt-IDs zeigen nur den Gruppennamen. */
  var GRUPPEN_NAMEN = { ziel: "Ziel", ernaehrung: "Ernährung", frei_von: "Frei von", proteinquelle: "Proteinquelle", kohlenhydrate: "Stärkebeilage", gemuese: "Gemüse", topping: "Topping", genussempfehlung: "Genussempfehlung", kcal_stufe: "kcal", protein_stufe: "Protein", carbs_stufe: "KH", fett_stufe: "Fett", gte: "Preis ab", lte: "Preis bis" };
  function fremdName(name, wert) {
    var key = String(name || "").split(".").pop();
    var gruppe = GRUPPEN_NAMEN[key];
    var w = String(wert == null ? "" : wert);
    if (/^gid:\/\//.test(w)) return gruppe || "Filter";
    return gruppe ? gruppe + ": " + w : w;
  }

  /* Sortierung aus der Adresse, die die Auswahl nicht anbietet (alte Links wie sort_by=title-descending)? */
  function sortUnbekannt(paare, werte) {
    return (paare || []).some(function (p) { return p[0] === "sort_by" && String(p[1]) !== "" && (werte || []).indexOf(String(p[1])) === -1; });
  }

  /* «Mehr laden» (18.10.2026): wie viele Platzhalter-Karten sofort beim Tippen erscheinen. rest = alle restlichen Treffer
     (data-vfko-rest), proSeite = Seitengrösse (data-vfko-pro-seite). Unbekannt: eine Seite, nie mehr als 48. */
  function platzhalterAnzahl(rest, proSeite) {
    var seite = Number(proSeite) > 0 ? Math.floor(Number(proSeite)) : 24;
    var r = rest === "" || rest == null || isNaN(Number(rest)) ? seite : Math.floor(Number(rest));
    return Math.max(0, Math.min(r, seite, 48));
  }

  /* Seitenzahl aus einer Adresse oder Suchzeile (?page=3 → 3, ohne → 1). */
  function seiteAus(suche) {
    var m = String(suche || "").match(/[?&]page=(\d+)/);
    return m ? Math.max(1, parseInt(m[1], 10)) : 1;
  }

  /* Gemerkter Stand «Mehr laden» je Adresse (sessionStorage): Schlüssel aus Pfad und Suche ohne Anker. */
  function mehrSchluessel(pfad, suche) {
    return "vfko-mehr:" + String(pfad || "") + String(suche || "");
  }

  /* Bis zu welcher Seite beim Zurückkommen nachgeladen wird (0 = nichts). Nur bei Zurück/Vorwärts ohne Back/Forward-Cache
     oder Neu laden; höchstens 15 Seiten über die Einstiegsseite hinaus (Speicher und Datenmenge am Handy). */
  var MEHR_MAX_SEITEN = 15;
  function wiederherstellenBis(stand, navTyp, startSeite) {
    if (navTyp !== "back_forward" && navTyp !== "reload") return 0;
    if (!stand || !(Number(stand.seite) > 0)) return 0;
    var start = Number(startSeite) > 0 ? Number(startSeite) : 1;
    var bis = Math.min(Math.floor(Number(stand.seite)), start + MEHR_MAX_SEITEN);
    return bis > start ? bis : 0;
  }

  /* ---------- Suche in der Kollektion (Pasci 30.10.2026) ---------- */
  var SUCH_INDEX = "vf-kollektion-index";     /* sections/vf-kollektion-index.liquid: Handle, Suchtext, Stelle (250 je Seite) */
  var SUCH_KARTEN = "vf-kollektion-karten";   /* sections/vf-kollektion-karten.liquid: die Karten, 36 je Seite */
  var SUCH_INDEX_PRO_SEITE = 250;             /* = paginate … by 250 in vf-kollektion-index (Test prüft die Kopplung) */
  var SUCH_KARTEN_PRO_SEITE = 36;             /* = paginate … by 36 in vf-kollektion-karten, = Treffer je Portion */
  var SUCH_MIN_ZEICHEN = 2;                   /* kürzere Begriffe suchen nicht (Hinweis am Feld); «Ei», «Öl» sind Zutaten */
  var SUCH_MAX_SEITEN = 20;                   /* Verzeichnis: höchstens 20 × 250 Gerichte */

  /* Text zum Vergleichen: klein, Umlaute und Akzente ohne Zeichen (wie die Handles der Zutaten-Tags: «zutaten.kase»),
     Eszett = ss, alles andere als Leerzeichen. «Käse», «kase» und «KÄSE» treffen dasselbe. */
  function suchNormal(text) {
    var t = String(text == null ? "" : text).toLowerCase().replace(/\u00df/g, "ss");
    if (typeof t.normalize === "function") t = t.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    else t = t.replace(/[äàáâ]/g, "a").replace(/[öòóô]/g, "o").replace(/[üùúû]/g, "u").replace(/[éèêë]/g, "e");
    return t.replace(/[^a-z0-9]+/g, " ").trim();
  }

  function suchWoerter(begriff) {
    var n = suchNormal(begriff);
    return n ? n.split(" ") : [];
  }

  /* Treffer = jedes Wort des Begriffs steht im Suchtext. Ab SUCH_TEILWORT_AB Zeichen auch als Wortteil («reis» findet «Basmatireis»),
     kürzere Wörter nur am Wortanfang («ei» findet «Eier», «zutaten.eier», «Poulet-Ei», nicht «Reis» oder «Dreierlei»; Handytest
     Pasci 31.10.2026). Wortgrenzen sind alle Zeichen, die suchNormal zu Leerzeichen macht (Leerzeichen, Bindestrich, Punkt im Tag-Handle). */
  var SUCH_TEILWORT_AB = 4;
  function passtSuche(woerter, text) {
    if (!woerter || !woerter.length) return false;
    var t = " " + suchNormal(text) + " ";
    return woerter.every(function (w) { return t.indexOf(w.length < SUCH_TEILWORT_AB ? " " + w : w) !== -1; });
  }

  /* Einträge des Verzeichnisses ([handle, text, stelle]), die passen, in der Reihenfolge der Kollektion, ohne Dubletten */
  function suchTreffer(eintraege, begriff) {
    var woerter = suchWoerter(begriff), da = {};
    return (eintraege || []).filter(function (e) {
      if (!e || !e[0] || da[e[0]] || !passtSuche(woerter, e[1])) return false;
      da[e[0]] = true;
      return true;
    });
  }

  /* Seiten von vf-kollektion-karten, auf denen die Treffer liegen (Stelle 0-basiert), aufsteigend */
  function trefferSeiten(stellen, pro) {
    var n = Number(pro) > 0 ? Number(pro) : SUCH_KARTEN_PRO_SEITE, da = {}, seiten = [];
    (stellen || []).forEach(function (st) {
      var x = Math.floor(Number(st) / n) + 1;
      if (x > 0 && !da[x]) { da[x] = true; seiten.push(x); }
    });
    return seiten.sort(function (a, b) { return a - b; });
  }

  /* Begriff aus einer Suchzeile («q», + und %20 als Leerzeichen); kein oder zu kurzer Begriff = "" (wie im Feld) */
  function begriffAus(suche) {
    var b = "";
    String(suche || "").replace(/^\?/, "").split("&").forEach(function (t) {
      var i = t.indexOf("=");
      if (i === -1 || t.slice(0, i) !== "q") return;
      try { b = decodeURIComponent(t.slice(i + 1).replace(/\+/g, " ")); } catch (e) { b = ""; }
    });
    b = b.trim();
    return b && !zuKurz(b) ? b : "";
  }

  /* Suchzeile ohne Begriff und ohne Seite (die Suche zeigt immer alle Treffer); Rest unverändert */
  function ohneBegriff(suche) {
    return String(suche || "").replace(/^\?/, "").split("&").filter(function (t) {
      var n = t.split("=")[0];
      return t && n !== "q" && n !== "page";
    }).join("&");
  }

  /* Filter-Parameter mit Begriff für die Adresse */
  function mitBegriff(params, begriff) {
    var p = ohneBegriff(params);
    return begriff ? (p ? p + "&" : "") + "q=" + encodeURIComponent(begriff).replace(/%20/g, "+") : p;
  }

  /* Zu kurz zum Suchen: weniger als SUCH_MIN_ZEICHEN Buchstaben/Ziffern (ohne Leerzeichen) */
  function zuKurz(begriff) {
    return suchNormal(begriff).replace(/ /g, "").length < SUCH_MIN_ZEICHEN;
  }

  /* Text der Trefferzeile (sichtbar und für Screenreader) */
  function trefferText(anzahl, begriff, kollektion) {
    var n = Number(anzahl) || 0;
    var wo = kollektion ? " in «" + kollektion + "»" : "";
    if (!n) return "Kein Gericht mit «" + begriff + "»" + wo;
    return n + (n === 1 ? " Gericht" : " Gerichte") + " mit «" + begriff + "»" + wo;
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = {
      stufenIndexe: stufenIndexe, aktiveStufen: aktiveStufen, reglerKorrigieren: reglerKorrigieren, bereichText: bereichText,
      parameterString: parameterString, paareErgaenzen: paareErgaenzen, mitZiele: mitZiele, mitFehlt: mitFehlt,
      ohneParameter: ohneParameter, sectionUrl: sectionUrl, neuNachSchluessel: neuNachSchluessel, fokusIndex: fokusIndex,
      fokusZiel: fokusZiel, gruppeBehalten: gruppeBehalten, sucheGeaendert: sucheGeaendert, spurIndex: spurIndex,
      naechsterRegler: naechsterRegler, zeigerGeste: zeigerGeste, ZIEH_SCHWELLE_PX: ZIEH_SCHWELLE_PX,
      paareAusSuche: paareAusSuche, suchPaare: suchPaare, auchWerte: auchWerte, fremdeFilter: fremdeFilter, fremdName: fremdName,
      sortUnbekannt: sortUnbekannt, platzhalterAnzahl: platzhalterAnzahl, seiteAus: seiteAus, mehrSchluessel: mehrSchluessel,
      wiederherstellenBis: wiederherstellenBis, MEHR_MAX_SEITEN: MEHR_MAX_SEITEN,
      suchNormal: suchNormal, suchWoerter: suchWoerter, passtSuche: passtSuche, suchTreffer: suchTreffer, trefferSeiten: trefferSeiten,
      begriffAus: begriffAus, ohneBegriff: ohneBegriff, mitBegriff: mitBegriff, trefferText: trefferText,
      SUCH_INDEX: SUCH_INDEX, SUCH_KARTEN: SUCH_KARTEN, SUCH_INDEX_PRO_SEITE: SUCH_INDEX_PRO_SEITE,
      SUCH_KARTEN_PRO_SEITE: SUCH_KARTEN_PRO_SEITE, SUCH_MIN_ZEICHEN: SUCH_MIN_ZEICHEN, zuKurz: zuKurz
    };
  }
  if (!root.document || !root.customElements) return;

  var doc = root.document;

  /* Gebündelter Aufruf; .abbrechen() verwirft einen geplanten (Zurück-Taste, direkter Ladevorgang). */
  function entprellt(fn, ms) {
    var t = null;
    function aufruf() {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { t = null; fn.apply(null, args); }, ms);
    }
    aufruf.abbrechen = function () { clearTimeout(t); t = null; };
    return aufruf;
  }

  /* ---------- Schieber ---------- */

  function schieberLesen(box) {
    var kaestchen = Array.prototype.slice.call(box.querySelectorAll("[data-vfko-stufen] input[data-vfko-stufe]"));
    var stufen = kaestchen.map(function (k) { return Number(k.getAttribute("data-vfko-stufe")); });
    return { kaestchen: kaestchen, stufen: stufen, schritt: Number(box.getAttribute("data-schritt")) || 1, einheit: box.getAttribute("data-einheit") || "" };
  }

  function schieberZeichnen(box, von, bis) {
    var d = schieberLesen(box);
    var n = d.stufen.length;
    var spur = box.querySelector("[data-vfko-spur]");
    if (spur && n) {
      spur.style.setProperty("--lo", (von / n) * 100 + "%");
      spur.style.setProperty("--hi", (bis / n) * 100 + "%");
    }
    var text = bereichText(d.stufen, von, bis, d.schritt, d.einheit);
    var aus = box.querySelector("[data-vfko-bereich]");
    if (aus) aus.textContent = text;
    box.querySelectorAll("[data-vfko-regler]").forEach(function (r) {
      var ist = r.getAttribute("data-vfko-regler") === "von";
      r.value = ist ? von : bis;
      r.setAttribute("aria-valuetext", ist ? (von < n ? d.stufen[von] + " " + d.einheit : "") : (bis > 0 ? d.stufen[bis - 1] + d.schritt - 1 + " " + d.einheit : ""));
    });
    var balken = box.querySelectorAll("[data-vfko-balken]");
    balken.forEach(function (b, i) { if (i >= von && i < bis) b.setAttribute("data-in", ""); else b.removeAttribute("data-in"); });
  }

  function schieberSetzen(box, von, bis) {
    var d = schieberLesen(box);
    var gewaehlt = aktiveStufen(d.stufen, von, bis);
    d.kaestchen.forEach(function (k, i) { k.checked = gewaehlt.indexOf(d.stufen[i]) !== -1; });
    schieberZeichnen(box, von, bis);
  }

  function schieberInit(box, beiAenderung) {
    /* Mit JS bedienen die Regler die Stufen-Kästchen: die Liste ist dann weder Tab-Stopp noch für Screenreader da
       (die Regler tragen aria-valuetext). Nach jedem Nachladen neu, weil die Liste ersetzt wird. */
    var liste = box.querySelector("[data-vfko-stufen]");
    if (liste) liste.setAttribute("inert", "");
    if (box._vfko) { schieberStandAusKaestchen(box); return; }
    box._vfko = true;
    schieberStandAusKaestchen(box);
    box.addEventListener("pointerdown", function (ev) { schieberZeiger(box, ev); });
    box.addEventListener("input", function (ev) {
      var r = ev.target;
      if (!r.hasAttribute || !r.hasAttribute("data-vfko-regler")) return;
      var regler = box.querySelectorAll("[data-vfko-regler]");
      var von = Number(regler[0].value), bis = Number(regler[1].value);
      var n = schieberLesen(box).stufen.length;
      var k = reglerKorrigieren(von, bis, n, r.getAttribute("data-vfko-regler"));
      schieberSetzen(box, k[0], k[1]);
      beiAenderung(box);
    });
  }

  /* Zeiger (Finger, Maus) auf der Spur: der nähere Daumen folgt, auch wenn beide übereinander liegen. Die Daumen selbst
     nehmen keine Zeiger an (CSS), die Tastatur bedient weiter die Regler direkt.
     Maus: sofort. Touch und Stift (Prüfrunde 2): pointerdown kommt, bevor der Browser entscheidet, ob gescrollt wird.
     Darum folgt der Daumen erst nach einer waagrechten Bewegung (zeigerGeste), reines Tippen springt beim Loslassen,
     Scrollen (senkrecht, pointercancel) ändert nichts. */
  function schieberZeiger(box, ev) {
    var spur = ev.target && ev.target.closest ? ev.target.closest("[data-vfko-spur]") : null;
    if (!spur || ev.button !== 0) return;
    var regler = box.querySelectorAll("[data-vfko-regler]");
    if (regler.length !== 2) return;
    var n = Number(regler[0].max) || 0;
    var r0 = spur.getBoundingClientRect();
    var pos = spurIndex(ev.clientX, r0.left, r0.width, n);
    var r = naechsterRegler(pos, Number(regler[0].value), Number(regler[1].value)) === "von" ? regler[0] : regler[1];
    var x0 = ev.clientX, y0 = ev.clientY;
    var geste = ev.pointerType === "mouse" ? "ziehen" : "";
    function setzen(e) {
      var i = String(Math.round(spurIndex(e.clientX, r0.left, r0.width, n)));
      if (i === r.value) return;
      r.value = i;
      r.dispatchEvent(new Event("input", { bubbles: true }));
    }
    function bewegt(e) {
      if (geste === "") {
        geste = zeigerGeste(e.clientX - x0, e.clientY - y0, ZIEH_SCHWELLE_PX);
        if (geste === "ziehen") r.focus({ preventScroll: true });
      }
      if (geste === "ziehen") setzen(e);
    }
    function los(e) {
      if (geste === "") { r.focus({ preventScroll: true }); setzen(e); } /* Tippen ohne Bewegung */
      ende();
    }
    function ende() {
      spur.removeEventListener("pointermove", bewegt);
      spur.removeEventListener("pointerup", los);
      spur.removeEventListener("pointercancel", ende);
    }
    if (spur.setPointerCapture) spur.setPointerCapture(ev.pointerId);
    spur.addEventListener("pointermove", bewegt);
    spur.addEventListener("pointerup", los);
    spur.addEventListener("pointercancel", ende);
    if (geste === "ziehen") { ev.preventDefault(); r.focus({ preventScroll: true }); setzen(ev); }
  }

  function schieberStandAusKaestchen(box) {
    var d = schieberLesen(box);
    var aktive = d.kaestchen.filter(function (k) { return k.checked; }).map(function (k) { return Number(k.getAttribute("data-vfko-stufe")); });
    var k = stufenIndexe(d.stufen, aktive);
    schieberZeichnen(box, k[0], k[1]);
  }

  /* ---------- Komponente ---------- */

  function panelBox(panel) { return panel.querySelector(".vfko-drawer__box, .vfko-feld__box"); }

  /* Angehängte Karten («Mehr laden») liegen nie im ersten Bild: Fotos ohne Vorrang und lazy wie die übrigen (Liquid gibt
     jeder Seite Vorrang für die ersten Fotos, auch ?page=2 als Einstieg, 18.10.2026). sizes «auto, …» wie im Lazy-Zweig
     von snippets/vf-gericht-karte.liquid. Im DOMParser-Dokument laden die Bilder noch nicht, nichts lädt doppelt. */
  function ohneVorrang(el) {
    el.querySelectorAll("img[fetchpriority], img[loading='eager']").forEach(function (img) {
      img.removeAttribute("fetchpriority");
      img.setAttribute("loading", "lazy");
      img.setAttribute("decoding", "async");
      var s = img.getAttribute("sizes");
      if (s && !/^\s*auto\b/.test(s)) img.setAttribute("sizes", "auto, " + s);
    });
  }

  if (root.customElements.get("vf-kollektion")) return;

  class VfKollektion extends HTMLElement {
    connectedCallback() {
      if (!this._init) this.starten();
      root.addEventListener("popstate", this._popstate); /* in disconnectedCallback wieder weg (Theme-Editor lädt Sections neu) */
      root.addEventListener("pagehide", this._pagehide);
    }

    disconnectedCallback() {
      root.removeEventListener("popstate", this._popstate);
      root.removeEventListener("pagehide", this._pagehide);
      if (this.panelOffen()) doc.documentElement.classList.remove("vfko-panel-offen");
    }

    starten() {
      this._init = true;
      /* Theme-Editor setzt Sections ohne ihr Inline-Skript neu ein: no-js hier entfernen, und eine Scroll-Sperre eines
         Panels der ersetzten Section aufheben (Prüfrunde 3) */
      this.classList.remove("no-js");
      doc.documentElement.classList.remove("vfko-panel-offen");
      this.sectionId = this.getAttribute("data-vfko-section");
      this.form = this.querySelector("[data-vfko-form]");
      this.ctrl = null;
      this.mehrCtrl = null;
      this.oeffner = null;
      this._suche = root.location.search;
      this.begriff = "";
      var self = this;
      /* Die bediente Gruppe reist mit dem geplanten Aufruf (Prüfrunde 2): eine frühere Antwort darf sie nicht vergessen. */
      this.planen = entprellt(function (gruppe) { self.laden(self.parameter(), { push: true, gruppe: gruppe }); }, WARTEZEIT_MS);
      this.planenRegler = entprellt(function (gruppe) { self.laden(self.parameter(), { push: true, gruppe: gruppe }); }, WARTEZEIT_REGLER_MS);
      this._popstate = function () {
        if (!sucheGeaendert(self._suche, root.location.search)) return;
        self._suche = root.location.search;
        var s = root.location.search.slice(1);
        /* Suche in der Kollektion: Begriff aus der Adresse; laden() reicht an suchen() weiter (Filter, dann Treffer) */
        if (self.suche) {
          self.begriffSetzen(begriffAus(s));
          if (self.begriff) s = ohneBegriff(s);
        }
        self.laden(s, {});
      };

      if (this.form) {
        this.form.addEventListener("submit", function (ev) { ev.preventDefault(); self.laden(self.parameter(), { push: true }); });
        this.form.addEventListener("change", function (ev) {
          var t = ev.target;
          if (!t || t.hasAttribute("data-vfko-regler")) return;
          if (t.matches('input[type="checkbox"], select, input[type="number"]')) {
            if (t.hasAttribute("data-vfko-mit")) self.mitAbgleichen(t.closest("[data-vfko-gruppe]"));
            if (t.hasAttribute("data-vfko-sort")) self.sortTitel(t);
            self.planen(self.gruppeVon(t));
          }
        });
      }
      /* Suche in der Kollektion (Pasci 30.10.2026): mit Skript nur in dieser Kollektion, auf dieser Seite (suchen); ohne
         Skript öffnet das GET-Formular die Suchseite. Ein leerer Begriff sucht nicht. */
      this.suche = this.querySelector("[data-vfko-suche]");
      this.suchStatus = this.querySelector("[data-vfko-such-status]");
      if (this.suche) {
        this.suche.addEventListener("submit", function (ev) {
          var q = self.suche.elements.q;
          var begriff = q.value.trim();
          ev.preventDefault();
          if (begriff && zuKurz(begriff)) {
            /* Unter 2 Zeichen nichts filtern, freundlicher Hinweis am Feld (verschwindet beim Tippen) */
            if (q.setCustomValidity) { q.setCustomValidity("Bitte gib mindestens " + SUCH_MIN_ZEICHEN + " Buchstaben ein."); q.reportValidity(); }
            return;
          }
          if (begriff) { self.suchen(begriff, { push: true }); return; }
          q.value = "";
          q.focus();
        });
        this.suche.addEventListener("input", function () { if (self.suche.elements.q.setCustomValidity) self.suche.elements.q.setCustomValidity(""); });
      }
      this.addEventListener("click", function (ev) { self.klick(ev); });
      this.addEventListener("keydown", function (ev) {
        if (ev.key !== "Escape") return;
        if (self.panelOffen()) { ev.preventDefault(); self.panelSchliessen(); }
        else if (self.suche && self.suche.classList.contains("is-offen") && self.suche.contains(doc.activeElement)) { ev.preventDefault(); self.sucheZeigen(false); }
      });
      this.schieberAlle();
      this.fremdeZeigen(root.location.search);
      this.introPruefen();
      this.ansichtSetzen(this.getAttribute("data-ansicht") === "liste" ? "liste" : "raster", false);
      /* Adresse mit Begriff (Neu laden, Zurück ohne Back/Forward-Cache): vor dem Nachziehen setzen, damit laden() ihn behält */
      var begriff0 = this.suche ? begriffAus(root.location.search) : "";
      this.begriffSetzen(begriff0);
      this.mitNachziehen();
      this.sortNachziehen();
      /* «Mehr laden»: Knopf statt Link, Stand merken und nach Zurück/Neu laden wiederherstellen (18.10.2026) */
      this._seite = seiteAus(root.location.search);
      this._pagehide = function () {
        self.standMerken();
        /* Verlässt man die Seite mitten in der Wiederherstellung, bleibt die Scroll-Wiederherstellung nicht auf «manual» */
        if (root.history && "scrollRestoration" in root.history) root.history.scrollRestoration = "auto";
      };
      this.mehrKnopfMachen();
      if (!begriff0) this.standWiederherstellen();
      else if (!this.ctrl) this.suchen(begriff0, { params: ohneBegriff(root.location.search) });
    }

    /* Runder Sortier-Knopf am Handy: aktive Sortierung im title (Screenreader hören sie am <select> selbst) */
    sortTitel(sel) {
      var l = sel.closest(".vfko-sort"), o = sel.options[sel.selectedIndex];
      if (l && o) l.title = "Sortieren: " + o.textContent.trim();
    }

    gruppeVon(el) {
      var g = el.closest ? el.closest("[data-vfko-gruppe]") : null;
      return g ? g.getAttribute("data-vfko-gruppe") : null;
    }

    schieberAlle() {
      var self = this;
      this.querySelectorAll("[data-vfko-schieber]").forEach(function (box) {
        schieberInit(box, function (b) { self.planenRegler(b.getAttribute("data-vfko-gruppe")); });
      });
    }

    parameter() {
      if (!this.form) return "";
      var paare = [], extras = [];
      new FormData(this.form).forEach(function (wert, name) { paare.push([name, wert]); });
      this.form.querySelectorAll("input[data-vfko-mit]:checked").forEach(function (k) { extras.push([k.name, k.getAttribute("data-vfko-mit")]); });
      this.form.querySelectorAll("input[data-vfko-auch]:checked").forEach(function (k) { auchWerte(k.getAttribute("data-vfko-auch")).forEach(function (w) { extras.push([k.name, w]); }); });
      var sort = this.form.querySelector("[data-vfko-sort]");
      return parameterString(paareErgaenzen(paare, extras), { sort_by: sort ? sort.getAttribute("data-vfko-standard") || "" : "" });
    }

    /* Lupe mit «such_filter» (Test R4 M1): Felder beim Absenden aus dem Filter-Formular, nicht aus der letzten Antwort.
       Grösse: roher Wert (data-vfko-roh, «Klein», den kennt die Suche) und die Gruppe. Ohne Einstellung kein Feld. */
    suchFelderBauen() {
      var box = this.suche && this.suche.querySelector("[data-vfko-such-filter]");
      if (!box || !this.form) return;
      var paare = [], extras = [];
      new FormData(this.form).forEach(function (wert, name) { paare.push([name, wert]); });
      this.form.querySelectorAll("input[data-vfko-roh]:checked").forEach(function (k) { extras.push([k.name, k.getAttribute("data-vfko-roh")]); });
      this.form.querySelectorAll("input[data-vfko-mit]:checked").forEach(function (k) { extras.push([k.name, k.getAttribute("data-vfko-mit")]); });
      this.form.querySelectorAll("input[data-vfko-auch]:checked").forEach(function (k) { auchWerte(k.getAttribute("data-vfko-auch")).forEach(function (w) { extras.push([k.name, w]); }); });
      box.textContent = "";
      suchPaare(paare, extras).forEach(function (p) {
        var f = doc.createElement("input");
        f.type = "hidden";
        f.name = p[0];
        f.value = p[1];
        box.appendChild(f);
      });
    }

    /* Suchseite (Test R4 M4): aktive Filter der Adresse, die das Formular nicht kennt, als verstecktes Feld (bleiben beim
       nächsten Klick) und als Chip (entfernt sie). suche = Suchzeile des Stands, der gerade dasteht. */
    fremdeZeigen(suche) {
      if (!this.form || !this.classList.contains("vfko--suche")) return;
      var box = this.form.querySelector("[data-vfko-fremd]");
      var chips = this.querySelector("[data-vfko-chips]");
      if (!box || !chips) return;
      box.textContent = "";
      chips.querySelectorAll("[data-vfko-fremd-chip]").forEach(function (c) { c.remove(); });
      var bekannt = [];
      this.form.querySelectorAll("input[name], select[name]").forEach(function (el) {
        var mitWert = el.type === "checkbox" || el.type === "radio";
        bekannt.push([el.name, mitWert ? el.value : null]);
        if (el.hasAttribute("data-vfko-mit")) bekannt.push([el.name, el.getAttribute("data-vfko-mit")]);
        auchWerte(el.getAttribute("data-vfko-auch")).forEach(function (w) { bekannt.push([el.name, w]); });
      });
      var fremd = fremdeFilter(paareAusSuche(suche), bekannt);
      if (!fremd.length) return;
      var vor = chips.querySelector(".vfko-chip--sort, .vfko-chips__leeren");
      var pfad = root.location.pathname;
      fremd.forEach(function (p) {
        var f = doc.createElement("input");
        f.type = "hidden";
        f.name = p[0];
        f.value = p[1];
        box.appendChild(f);
        var a = doc.createElement("a");
        var rest = ohneParameter(suche, p[0], p[1]);
        a.className = "vfko-chip";
        a.href = pfad + (rest ? "?" + rest : "");
        a.rel = "nofollow";
        a.setAttribute("data-vfko-link", "");
        a.setAttribute("data-vfko-fremd-chip", "");
        a.textContent = fremdName(p[0], p[1]);
        var x = doc.createElement("span");
        x.className = "vfko-chip__x";
        x.setAttribute("aria-hidden", "true");
        x.textContent = "×";
        var sr = doc.createElement("span");
        sr.className = "visually-hidden";
        sr.textContent = " entfernen";
        a.appendChild(x);
        a.appendChild(sr);
        chips.insertBefore(a, vor);
      });
      var total = this.querySelector('[data-vfko-text="aktiv-total"]'); /* Zahl an «Alle Filter» zählt sie mit */
      if (total) total.textContent = String((parseInt(total.textContent, 10) || 0) + fremd.length);
      if (!chips.querySelector(".vfko-chips__leeren")) {
        var reset = this.querySelector(".vfko-drawer__reset[href]");
        if (reset) {
          var l = doc.createElement("a");
          l.className = "vfko-chips__leeren";
          l.href = reset.getAttribute("href");
          l.rel = "nofollow";
          l.setAttribute("data-vfko-link", "");
          l.textContent = "Alle löschen";
          chips.appendChild(l);
        }
      }
    }

    /* Alte Links mit einer Sortierung, die die Auswahl nicht kennt (Test R4 N1): einmal mit dem Standard nachladen und die
       Adresse ersetzen, damit Liste und Auswahl übereinstimmen. */
    sortNachziehen() {
      var sel = this.form && this.form.querySelector("[data-vfko-sort]");
      if (!sel) return;
      var werte = Array.prototype.map.call(sel.options, function (o) { return o.value; });
      if (sortUnbekannt(paareAusSuche(root.location.search), werte)) this.laden(this.parameter(), { ersetzen: true });
    }

    mitEintraege(gruppe) {
      return Array.prototype.map.call(gruppe.querySelectorAll("input[data-vfko-wert]"), function (k) {
        return { el: k, wert: k.getAttribute("data-vfko-wert"), angehakt: k.checked, mit: k.getAttribute("data-vfko-mit") };
      });
    }

    /* «Kalt»/«Warm» angehakt: «Warm oder Kalt» angehakt und gesperrt («mit dabei»); sonst wieder frei. */
    mitAbgleichen(gruppe) {
      if (!gruppe) return;
      var eintraege = this.mitEintraege(gruppe);
      var ziele = mitZiele(eintraege);
      eintraege.forEach(function (e) {
        var k = e.el;
        if (ziele.indexOf(e.wert) !== -1) { k.checked = true; k.disabled = true; k.setAttribute("data-vfko-mitgewaehlt", ""); }
        else if (k.hasAttribute("data-vfko-mitgewaehlt")) { k.checked = false; k.disabled = false; k.removeAttribute("data-vfko-mitgewaehlt"); }
      });
    }

    /* Direktlink nur mit «Kalt» (alte Mail, von Hand gebaut): einmal mit «Warm oder Kalt» nachladen und die Adresse
       ersetzen, damit Zahl und Auswahl schon jetzt dem entsprechen, was der nächste Klick schicken würde (Prüfrunde 2). */
    mitNachziehen() {
      var self = this, fehlt = false;
      this.querySelectorAll("[data-vfko-gruppe]").forEach(function (g) {
        if (!g.querySelector("input[data-vfko-mit]") || !mitFehlt(self.mitEintraege(g))) return;
        self.mitAbgleichen(g);
        fehlt = true;
      });
      if (fehlt) this.laden(this.parameter(), { ersetzen: true });
    }

    /* Lupe: Suchfeld unter der Zeile auf/zu. Offen springt der Fokus ins Feld, zu (Lupe, Esc) zurück auf die Lupe. */
    sucheZeigen(an, ohneFokus) {
      var lupe = this.querySelector("[data-vfko-lupe]");
      if (!this.suche || !lupe) return;
      this.suche.classList.toggle("is-offen", an);
      lupe.setAttribute("aria-expanded", an ? "true" : "false");
      if (ohneFokus) return;
      if (an) this.suche.elements.q.focus(); else lupe.focus();
    }

    /* Ansicht Raster/Liste (Pasci 10.10.2026, Mockup v3) */
    ansichtSetzen(art, merken) {
      var vorher = this.getAttribute("data-ansicht") === "liste" ? "liste" : "raster";
      if (art === "liste") this.setAttribute("data-ansicht", "liste"); else this.removeAttribute("data-ansicht");
      /* Gemerkte Kartenhöhen (content-visibility, vf-kollektion.css) gehören zur alten Ansicht: zwei Frames alle Karten zeichnen */
      if (vorher !== art && root.requestAnimationFrame) {
        var k = this;
        k.classList.add("vfko--hoehe-neu");
        root.requestAnimationFrame(function () { root.requestAnimationFrame(function () { k.classList.remove("vfko--hoehe-neu"); }); });
      }
      this.querySelectorAll("[data-vfko-ansicht]").forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-vfko-ansicht") === art ? "true" : "false"); });
      if (merken) { try { root.localStorage.setItem("vfko-ansicht", art); } catch (e) { /* ohne Speicher gilt die Wahl nur auf dieser Seite */ } }
    }

    klick(ev) {
      var t = ev.target && ev.target.closest ? ev.target.closest("[data-vfko-oeffnen],[data-vfko-schliessen],[data-vfko-stufen-leeren],[data-vfko-link],[data-vfko-mehr],[data-vfko-mehr-werte],[data-vfko-intro-mehr],[data-vfko-ansicht],[data-vfko-lupe],[data-vfko-sort-weg],[data-vfko-such-weg],[data-vfko-such-mehr]") : null;
      if (!t || !this.contains(t)) return;
      if (t.hasAttribute("data-vfko-ansicht")) { ev.preventDefault(); this.ansichtSetzen(t.getAttribute("data-vfko-ansicht"), true); return; }
      if (t.hasAttribute("data-vfko-lupe")) { ev.preventDefault(); this.sucheZeigen(t.getAttribute("aria-expanded") !== "true"); return; }
      if (t.hasAttribute("data-vfko-such-weg")) { ev.preventDefault(); this.sucheAufheben(); return; }
      if (t.hasAttribute("data-vfko-such-mehr")) { ev.preventDefault(); this.suchMehr(t); return; }
      if (t.hasAttribute("data-vfko-sort-weg")) {
        ev.preventDefault();
        var sel = this.form && this.form.querySelector("[data-vfko-sort]");
        if (!sel) return;
        sel.value = sel.getAttribute("data-vfko-standard") || "";
        this.sortTitel(sel);
        var alle = Array.prototype.slice.call(this.querySelectorAll("[data-vfko-chips] .vfko-chip"));
        this.laden(this.parameter(), { push: true, chip: alle.indexOf(t) });
        return;
      }
      if (t.hasAttribute("data-vfko-oeffnen")) {
        ev.preventDefault();
        var name = t.getAttribute("data-vfko-oeffnen") || "drawer";
        if (t.getAttribute("aria-expanded") === "true") this.panelSchliessen(); else this.panelOeffnen(name, t.getAttribute("data-vfko-ziel"), t);
        return;
      }
      if (t.hasAttribute("data-vfko-schliessen")) { ev.preventDefault(); this.panelSchliessen(); return; }
      if (t.hasAttribute("data-vfko-stufen-leeren")) { ev.preventDefault(); this.stufenLeeren(); return; }
      if (t.hasAttribute("data-vfko-mehr-werte")) { ev.preventDefault(); this.mehrWerte(t); return; }
      if (t.hasAttribute("data-vfko-intro-mehr")) { ev.preventDefault(); this.introUmschalten(t); return; }
      if (t.hasAttribute("data-vfko-mehr")) { ev.preventDefault(); this.mehrLaden(t); return; }
      if (t.hasAttribute("data-vfko-link")) {
        var url = new URL(t.getAttribute("href"), root.location.href);
        if (url.pathname !== root.location.pathname) return; /* z. B. Tag-Seite verlassen: normaler Seitenwechsel */
        ev.preventDefault();
        var suche = url.search.slice(1);
        if (t.hasAttribute("data-vfko-ohne-wert")) suche = ohneParameter(suche, t.getAttribute("data-vfko-ohne-name"), t.getAttribute("data-vfko-ohne-wert"));
        auchWerte(t.getAttribute("data-vfko-ohne-werte")).forEach(function (w) { suche = ohneParameter(suche, t.getAttribute("data-vfko-ohne-name"), w); }); /* Grössen-Chip der Suche: alle Werte der Grösse */
        var chips = Array.prototype.slice.call(this.querySelectorAll("[data-vfko-chips] .vfko-chip"));
        this.laden(suche, { push: true, chip: chips.indexOf(t) });
      }
    }

    /* ---------- Laden und Einsetzen ---------- */

    /* opt = { push (neuer Verlaufseintrag), ersetzen (Adresse ersetzen), gruppe (beim Planen bediente Gruppe),
       chip (Index des angeklickten Chips) } */
    laden(params, opt) {
      var self = this;
      opt = opt || {};
      /* Der neueste Ladevorgang gewinnt: geplante Aufrufe (z. B. vor der Zurück-Taste) und «Mehr laden» verfallen. */
      this.planen.abbrechen();
      this.planenRegler.abbrechen();
      if (this.mehrCtrl && this.mehrCtrl.abort) this.mehrCtrl.abort();
      this.mehrCtrl = null;
      if (this.ctrl && this.ctrl.abort) this.ctrl.abort();
      var ctrl = typeof AbortController === "function" ? new AbortController() : {};
      this.ctrl = ctrl;
      var vorher = doc.activeElement;
      var raster = this.querySelector("[data-vfko-raster]");
      if (raster) raster.setAttribute("aria-busy", "true");
      this.fehler(false);
      var url = sectionUrl(root.location.pathname, params, this.sectionId);
      root.fetch(url, { signal: ctrl.signal, headers: { Accept: "text/html" } })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); })
        .then(function (html) {
          if (self.ctrl !== ctrl) return;
          var neu = new DOMParser().parseFromString(html, "text/html").querySelector("vf-kollektion");
          if (!neu) throw new Error("Section ohne Inhalt");
          self.einsetzen(neu, opt.gruppe);
          self._seite = seiteAus("?" + (params || ""));
          self.fremdeZeigen(params);
          self.fokusRetten(vorher, opt.chip);
          /* Suche aktiv: Filter, Chips und Zahlen stehen, die Treffer holt suchen() mit denselben Filtern (eigene Adresse) */
          if (self.begriff) { self.suchen(self.begriff, { params: params, push: opt.push, ersetzen: opt.ersetzen }); return; }
          if (opt.push || opt.ersetzen) {
            var ziel = root.location.pathname + (params ? "?" + params : "");
            if (ziel !== root.location.pathname + root.location.search) root.history[opt.push ? "pushState" : "replaceState"]({ vfko: params }, "", ziel);
            self._suche = root.location.search;
          }
        })
        .catch(function (e) {
          if ((e && e.name === "AbortError") || self.ctrl !== ctrl) return;
          self.fehler(true);
        })
        .then(function () {
          if (self.ctrl !== ctrl) return; /* ein neuerer Ladevorgang läuft: Raster bleibt «beschäftigt» */
          self.ctrl = null;
          if (raster) raster.setAttribute("aria-busy", "false");
        });
    }

    /* ---------- Suche in der Kollektion (Pasci 30.10.2026) ----------
       Technik: ein Abruf des Suchverzeichnisses (sections/vf-kollektion-index.liquid, bis 250 Gerichte je Abruf, mit den
       aktiven Filtern und der Sortierung, also genau die Gerichte dieser Kollektion in Raster-Reihenfolge), Vergleich hier
       (Name, Zutaten, Proteinquelle, Labels, Ernährung, Stärkebeilage, Gemüse, Topping), dann nur die Seiten der
       Karten-Section (je 36), auf denen die ersten 36 Treffer liegen; «Mehr laden» holt die nächsten 36 (Prüfung 30.10.:
       50 Karten ≈ 280 KB, ein breiter Begriff holte sonst ~1 MB). Shopify kennt keine Textsuche innerhalb einer Kollektion;
       die Suchseite würde das ganze Sortiment durchsuchen. Alle Abrufe hängen an einem AbortController (this.ctrl wie
       laden(), «Mehr laden» this.mehrCtrl), jede Antwort prüft, ob sie noch die aktuelle ist. Adresse: Filter + q
       (pushState), nie als Link im HTML. Während der Suche zeigt der Zähler der Leiste (role=status) die Trefferzahl und
       spricht nicht; es spricht nur die Statuszeile der Suche (data-vfko-such-status).
       Esc im Suchfeld schliesst nur das Feld (Lupe), die Treffer bleiben; «Suche aufheben» und Zurück in einen Stand ohne
       Begriff schliessen das Feld und zeigen wieder alle Gerichte. */

    begriffSetzen(begriff) {
      var vorher = this.begriff;
      this.begriff = begriff || "";
      this.classList.toggle("vfko--begriff", !!this.begriff);
      var zaehler = this.querySelector(".vfko-zaehler");
      if (zaehler) { if (this.begriff) zaehler.removeAttribute("role"); else zaehler.setAttribute("role", "status"); }
      if (!this.suche) return;
      var q = this.suche.elements.q;
      if (q && q.value.trim() !== this.begriff) q.value = this.begriff;
      if (this.begriff) this.sucheZeigen(true, true);
      else if (vorher) this.sucheZeigen(false, true);
    }

    /* Karten-Seiten holen (Section vf-kollektion-karten) und die <li> je Handle sammeln */
    kartenHolen(pfad, params, seiten, ctrl) {
      return Promise.all(seiten.map(function (n) {
        return root.fetch(sectionUrl(pfad, (params ? params + "&" : "") + "page=" + n, SUCH_KARTEN), { signal: ctrl.signal, headers: { Accept: "text/html" } })
          .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); })
          .then(function (html) { return new DOMParser().parseFromString(html, "text/html"); });
      })).then(function (docs) {
        var karten = {}, kopf = null;
        docs.forEach(function (d) {
          kopf = kopf || d.querySelector(".vfko-listenkopf");
          d.querySelectorAll("[data-vfko-karten] > li").forEach(function (li) {
            var k = li.querySelector("[data-handle]");
            if (k) karten[k.getAttribute("data-handle")] = li;
          });
        });
        return { karten: karten, kopf: kopf };
      });
    }

    /* opt = { params (Filter ohne Begriff, sonst aus dem Formular), push, ersetzen } */
    suchen(begriff, opt) {
      var self = this;
      opt = opt || {};
      this.planen.abbrechen();
      this.planenRegler.abbrechen();
      if (this.mehrCtrl && this.mehrCtrl.abort) this.mehrCtrl.abort();
      this.mehrCtrl = null;
      if (this.ctrl && this.ctrl.abort) this.ctrl.abort();
      var ctrl = typeof AbortController === "function" ? new AbortController() : {};
      this.ctrl = ctrl;
      this.begriffSetzen(begriff);
      var params = ohneBegriff(opt.params != null ? opt.params : this.parameter());
      var pfad = root.location.pathname;
      var raster = this.querySelector("[data-vfko-raster]");
      if (raster) raster.setAttribute("aria-busy", "true");
      this.fehler(false);
      var verzeichnis = function (seite) {
        return root.fetch(sectionUrl(pfad, (params ? params + "&" : "") + "page=" + seite, SUCH_INDEX), { signal: ctrl.signal, headers: { Accept: "text/html" } })
          .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); })
          .then(function (html) {
            var el = new DOMParser().parseFromString(html, "text/html").querySelector("script[data-vfko-index]");
            if (!el) throw new Error("Suchverzeichnis fehlt");
            return JSON.parse(el.textContent);
          });
      };
      var treffer = [];
      verzeichnis(1)
        .then(function (erste) {
          var weitere = [];
          for (var n = 2; n <= Math.min(Number(erste.seiten) || 1, SUCH_MAX_SEITEN); n++) weitere.push(verzeichnis(n));
          return Promise.all(weitere).then(function (rest) {
            return [erste].concat(rest).reduce(function (alle, v) { return alle.concat(v.g || []); }, []);
          });
        })
        .then(function (eintraege) {
          if (self.ctrl !== ctrl) return null;
          treffer = suchTreffer(eintraege, begriff);
          var erste = treffer.slice(0, SUCH_KARTEN_PRO_SEITE);
          return self.kartenHolen(pfad, params, trefferSeiten(erste.map(function (e) { return e[2]; }), SUCH_KARTEN_PRO_SEITE), ctrl);
        })
        .then(function (erg) {
          if (!erg || self.ctrl !== ctrl) return;
          self._such = { begriff: begriff, params: params, pfad: pfad, treffer: treffer, gezeigt: 0 };
          self.trefferZeigen(erg);
          self._seite = 1;
          if (opt.push || opt.ersetzen) {
            var ziel = pfad + "?" + mitBegriff(params, begriff);
            if (ziel !== root.location.pathname + root.location.search) root.history[opt.push ? "pushState" : "replaceState"]({ vfko: mitBegriff(params, begriff) }, "", ziel);
          }
          self._suche = root.location.search;
        })
        .catch(function (e) {
          if ((e && e.name === "AbortError") || self.ctrl !== ctrl) return;
          self.fehler(true);
        })
        .then(function () {
          if (self.ctrl !== ctrl) return;
          self.ctrl = null;
          if (raster) raster.setAttribute("aria-busy", "false");
        });
    }

    /* Karten einer Portion an die Liste hängen (Reihenfolge der Kollektion); gibt die erste neue Karte zurück */
    trefferAnhaengen(liste, portion, karten) {
      var erste = null;
      portion.forEach(function (e) {
        var li = karten[e[0]];
        if (!li) return;
        ohneVorrang(li);
        var neu = doc.importNode(li, true);
        liste.appendChild(neu);
        erste = erste || neu;
      });
      return erste;
    }

    /* «Mehr laden» der Suche (dieselbe Optik und dieselben Platzhalter wie das normale «Mehr laden») */
    suchNav(raster) {
      var st = this._such, alt = raster.querySelector("[data-vfko-such-seiten]");
      if (alt) alt.remove();
      var rest = st.treffer.length - st.gezeigt;
      if (rest <= 0) return;
      var nav = doc.createElement("nav");
      nav.className = "vfko-seiten";
      nav.setAttribute("aria-label", "Weitere Treffer");
      nav.setAttribute("data-vfko-seiten", "");
      nav.setAttribute("data-vfko-such-seiten", "");
      nav.setAttribute("data-vfko-rest", String(rest));
      nav.setAttribute("data-vfko-pro-seite", String(SUCH_KARTEN_PRO_SEITE));
      var b = doc.createElement("button");
      b.type = "button";
      b.className = "vfp-btn vfp-btn--ghost vfko-mehr";
      b.setAttribute("data-vfko-such-mehr", "");
      b.textContent = "Mehr laden ";
      var n = doc.createElement("span");
      n.className = "vfko-mehr__rest";
      n.textContent = "(" + rest + " weitere)";
      b.appendChild(n);
      nav.appendChild(b);
      raster.appendChild(nav);
    }

    /* Treffer anstelle des Rasters: Zeile mit Zahl, «Im ganzen Sortiment suchen» und «Suche aufheben», dann die ersten 36
       Karten (aus den Antworten der Karten-Section), darunter «Mehr laden», solange Treffer fehlen. */
    trefferZeigen(erg) {
      var raster = this.querySelector("[data-vfko-raster]");
      var st = this._such;
      if (!raster || !st) return;
      var liste = doc.createElement("ul");
      liste.className = "vfko-raster";
      liste.setAttribute("role", "list");
      liste.setAttribute("data-vfko-karten", "");
      var portion = st.treffer.slice(0, SUCH_KARTEN_PRO_SEITE);
      this.trefferAnhaengen(liste, portion, erg.karten);
      st.gezeigt = portion.length;
      var n = liste.children.length ? st.treffer.length : 0;
      var text = trefferText(n, st.begriff, this.kollektionName());
      var el = function (tag, klasse, inhalt) {
        var x = doc.createElement(tag);
        if (klasse) x.className = klasse;
        if (inhalt) x.textContent = inhalt;
        return x;
      };
      var aufheben = el("button", n ? "vfko-treffer__weg" : "vfp-btn vfp-btn--ghost vfko-leer__knopf", "Suche aufheben");
      aufheben.type = "button";
      aufheben.setAttribute("data-vfko-such-weg", "");
      var alle = el("a", n ? "vfko-treffer__alle" : "vfp-btn vfko-leer__knopf", "Im ganzen Sortiment suchen");
      alle.href = this.alleSuchen(st.begriff);
      alle.rel = "nofollow";
      raster.textContent = "";
      if (n) {
        var zeile = el("div", "vfko-treffer");
        zeile.appendChild(el("p", "vfko-treffer__text", text));
        var aktionen = el("p", "vfko-treffer__aktionen");
        aktionen.appendChild(alle);
        aktionen.appendChild(aufheben);
        zeile.appendChild(aktionen);
        raster.appendChild(zeile);
        raster.appendChild(el("h2", "visually-hidden", "Gerichte"));
        if (erg.kopf) raster.appendChild(doc.importNode(erg.kopf, true));
        raster.appendChild(liste);
        this.suchNav(raster);
      } else {
        var leer = el("div", "vfko-leer");
        leer.appendChild(el("h2", "vfko-leer__titel", text));
        var filter = /(^|&)filter\./.test(st.params);
        leer.appendChild(el("p", "vfko-leer__text", (filter ? "Lass einen Filter weg, probier ein anderes Wort" : "Probier ein anderes Wort") + " oder schau im ganzen Sortiment nach."));
        var knoepfe = el("p", "vfko-leer__knoepfe");
        knoepfe.appendChild(alle);
        knoepfe.appendChild(aufheben);
        leer.appendChild(knoepfe);
        raster.appendChild(leer);
      }
      /* Zähler der Leiste und Knopf im Drawer: Trefferzahl (still, s. begriffSetzen); gesprochen wird nur die Statuszeile */
      var zahl = n + (n === 1 ? " Gericht" : " Gerichte");
      this.querySelectorAll('[data-vfko-text="zaehler"]').forEach(function (z) { z.textContent = zahl; });
      this.statusSagen(text);
    }

    suchMehr(knopf) {
      var self = this, st = this._such;
      if (!st || knopf.getAttribute("aria-busy") === "true" || this.ctrl) return;
      var portion = st.treffer.slice(st.gezeigt, st.gezeigt + SUCH_KARTEN_PRO_SEITE);
      if (!portion.length) return;
      var ctrl = typeof AbortController === "function" ? new AbortController() : {};
      this.mehrCtrl = ctrl;
      knopf.setAttribute("aria-busy", "true");
      this.platzhalterSetzen(knopf);
      this.kartenHolen(st.pfad, st.params, trefferSeiten(portion.map(function (e) { return e[2]; }), SUCH_KARTEN_PRO_SEITE), ctrl)
        .then(function (erg) {
          self.platzhalterWeg();
          if (self.mehrCtrl !== ctrl || self._such !== st) return;
          var liste = self.querySelector("[data-vfko-karten]"), raster = self.querySelector("[data-vfko-raster]");
          if (!liste || !raster) return;
          var erste = self.trefferAnhaengen(liste, portion, erg.karten);
          st.gezeigt += portion.length;
          self.suchNav(raster);
          var fokus = erste ? erste.querySelector("h3 a") : null;
          if (fokus) fokus.focus({ preventScroll: true });
        })
        .catch(function (e) {
          self.platzhalterWeg();
          knopf.removeAttribute("aria-busy");
          if (e && e.name === "AbortError") return;
          self.fehler(true);
        })
        .then(function () { if (self.mehrCtrl === ctrl) self.mehrCtrl = null; });
    }

    kollektionName() {
      var h = this.querySelector(".vfko-titel");
      var t = h && h.firstChild && h.firstChild.nodeType === 3 ? h.firstChild.textContent : "";
      return String(t || "").trim();
    }

    /* Adresse der Suchseite mit demselben Begriff (Formular der Lupe: type, options[prefix], mit «such_filter» die Filter) */
    alleSuchen(begriff) {
      this.suchFelderBauen();
      var paare = [];
      new FormData(this.suche).forEach(function (wert, name) {
        if (name !== "q") paare.push(encodeURIComponent(name) + "=" + encodeURIComponent(wert));
      });
      /* Suche nur nach Name und Zutaten (assets/vf-suche-feld.js, global geladen); fehlt das Skript, der Begriff roh */
      var q = root.VFSucheFeld && root.VFSucheFeld.feldQuery ? root.VFSucheFeld.feldQuery(begriff) : begriff;
      paare.unshift("q=" + encodeURIComponent(q));
      return (this.suche.getAttribute("action") || "/search") + "?" + paare.join("&");
    }

    sucheAufheben() {
      this._such = null;
      this.begriffSetzen(""); /* schliesst das Feld */
      var lupe = this.querySelector("[data-vfko-lupe]");
      if (lupe) lupe.focus(); /* der Knopf verschwindet mit den Treffern; Fokus auf die Lupe wie nach Esc */
      this.statusSagen("Suche aufgehoben, alle Gerichte stehen wieder da");
      this.laden(this.parameter(), { push: true });
    }

    /* aria-live: leeren und kurz danach setzen, damit auch derselbe Text wieder vorgelesen wird */
    statusSagen(text) {
      var s = this.suchStatus;
      if (!s) return;
      s.textContent = "";
      root.setTimeout(function () { s.textContent = text; }, 60);
    }

    /* Lag der Fokus auf einem Element, das beim Einsetzen ersetzt wurde (Chip, «Alle löschen», Leer-Knopf, Feld einer
       nachgeladenen Gruppe), und ist er jetzt auf <body>: siehe fokusZiel. */
    fokusRetten(vorher, chip) {
      if (!vorher || doc.contains(vorher)) return;
      if (doc.activeElement && doc.activeElement !== doc.body) return;
      var panel = this.panelOffen();
      var gleich = vorher.id ? doc.getElementById(vorher.id) : null;
      if (gleich && (!this.contains(gleich) || (panel && !panel.contains(gleich)))) gleich = null;
      var chips = this.querySelectorAll("[data-vfko-chips] .vfko-chip");
      var z = fokusZiel({ gleich: !!gleich, panel: !!panel, chip: chip, chips: chips.length });
      var ziel = z.art === "gleich" ? gleich
        : z.art === "panel" ? panelBox(panel).querySelector("[data-vfko-schliessen]")
        : z.art === "chip" ? chips[z.index] : this.querySelector(".vfko-pill--alle");
      if (ziel) ziel.focus({ preventScroll: true });
    }

    einsetzen(neu, gruppe) {
      var self = this;
      /* Filtergruppen: die bediente Gruppe behält ihre Felder (Fokus, Regler), nur Zähler und Balken werden nachgeführt. */
      neu.querySelectorAll("[data-vfko-gruppe]").forEach(function (ng) {
        var key = ng.getAttribute("data-vfko-gruppe");
        var alt = self.querySelector('[data-vfko-gruppe="' + key + '"]');
        if (!alt) return;
        if (gruppeBehalten(gruppe, key)) self.zaehlerAngleichen(alt, ng); else alt.innerHTML = ng.innerHTML;
      });
      /* Texte (Zähler, Pillen-Zahlen, Gruppen-Zahlen, Bereichstexte) */
      neu.querySelectorAll("[data-vfko-text]").forEach(function (nt) {
        var key = nt.getAttribute("data-vfko-text");
        if (key === "zaehler" && self.begriff) return; /* Suche aktiv: der Zähler zeigt die Treffer (trefferZeigen) */
        self.querySelectorAll('[data-vfko-text="' + key + '"]').forEach(function (at) { at.textContent = nt.textContent; });
      });
      /* Pillen und Drawer-Gruppen: Zustand und Sichtbarkeit (z. B. Ziel erscheint wieder, sobald mehrere Ziele Treffer haben) */
      neu.querySelectorAll("[data-vfko-pill]").forEach(function (np) {
        var ap = self.querySelector('[data-vfko-pill="' + np.getAttribute("data-vfko-pill") + '"]');
        if (ap) { ap.className = np.className; ap.hidden = np.hidden; }
      });
      neu.querySelectorAll("[data-vfko-details]").forEach(function (nd) {
        var ad = self.querySelector('[data-vfko-details="' + nd.getAttribute("data-vfko-details") + '"]');
        if (ad) ad.hidden = nd.hidden;
      });
      ["[data-vfko-chips]", "[data-vfko-raster]", "[data-vfko-alt]"].forEach(function (sel) {
        if (sel === "[data-vfko-raster]" && self.begriff) return; /* Treffer der Suche bleiben bis zur neuen Antwort */
        var a = self.querySelector(sel), n = neu.querySelector(sel);
        if (a && n) a.innerHTML = n.innerHTML;
      });
      var nsort = neu.querySelector("[data-vfko-sort]"), asort = this.querySelector("[data-vfko-sort]");
      if (nsort && asort && asort.value !== nsort.value) { asort.value = nsort.value; this.sortTitel(asort); }
      this.schieberAlle();
      this.mehrKnopfMachen();
    }

    /* Bediente Gruppe: je Wert (Kästchen oder Balken) Zähler, Sperre und Balkenhöhe aus der neuen Antwort übernehmen.
       Markup: <input data-vfko-wert><label>…<span data-vfko-n>  bzw.  <i data-vfko-balken data-vfko-wert style="--h"> */
    zaehlerAngleichen(alt, neu) {
      var alte = {};
      alt.querySelectorAll("[data-vfko-wert]").forEach(function (k) { alte[k.tagName + "|" + k.getAttribute("data-vfko-wert")] = k; });
      neu.querySelectorAll("[data-vfko-wert]").forEach(function (nw) {
        var aw = alte[nw.tagName + "|" + nw.getAttribute("data-vfko-wert")];
        if (!aw) return;
        if (nw.hasAttribute("data-vfko-balken")) { aw.style.setProperty("--h", nw.style.getPropertyValue("--h")); return; }
        var nn = nw.nextElementSibling ? nw.nextElementSibling.querySelector("[data-vfko-n]") : null;
        var an = aw.nextElementSibling ? aw.nextElementSibling.querySelector("[data-vfko-n]") : null;
        if (nn && an) an.textContent = nn.textContent;
        if (aw.type === "checkbox" && !aw.checked && !aw.hasAttribute("data-vfko-stufe")) aw.disabled = nw.disabled;
      });
    }

    fehler(an) {
      var f = this.querySelector("[data-vfko-fehler]");
      if (f) f.hidden = !an;
    }

    /* ---------- Mehr laden: nächste Seite anhängen ---------- */

    /* Hängt Gericht-Karten und (Suche) Beiträge/Seiten der nächsten Seite an, ohne Dubletten; ersetzt die Seiten-Navigation.
       Läuft ein Filter-Ladevorgang, wartet «Mehr laden» nicht: die Antwort gehörte zur alten Auswahl. Bricht ein Filter-
       Ladevorgang «Mehr laden» ab, wird der Knopf wieder frei (scheitert der Filter, bleibt er bedienbar). */
    mehrLaden(knopf) {
      var self = this;
      var href = knopf.getAttribute("href") || knopf.getAttribute("data-href");
      if (!href || knopf.getAttribute("aria-busy") === "true" || this.ctrl) return Promise.resolve(false);
      var url = new URL(href, root.location.href);
      var ctrl = typeof AbortController === "function" ? new AbortController() : {};
      this.mehrCtrl = ctrl;
      knopf.setAttribute("aria-busy", "true");
      this.platzhalterSetzen(knopf);
      return root.fetch(sectionUrl(url.pathname, url.search.slice(1), this.sectionId), { signal: ctrl.signal, headers: { Accept: "text/html" } })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); })
        .then(function (html) {
          if (self.mehrCtrl !== ctrl) { self.platzhalterWeg(); return false; }
          var neu = new DOMParser().parseFromString(html, "text/html");
          if (!neu.querySelector("[data-vfko-raster]")) throw new Error("Section ohne Inhalt");
          self.platzhalterWeg();
          var erste = self.anhaengen(neu, "[data-vfko-karten]", function (li) { var k = li.querySelector("[data-handle]"); return k ? k.getAttribute("data-handle") : ""; });
          ["artikel", "seiten"].forEach(function (art) {
            var e = self.anhaengen(neu, '[data-vfko-sonstige="' + art + '"] ul', function (li) { var a = li.querySelector("a"); return a ? a.getAttribute("href") : ""; }, art);
            erste = erste || e;
          });
          var nseiten = neu.querySelector("[data-vfko-seiten]"), aseiten = self.querySelector("[data-vfko-seiten]");
          if (aseiten) { if (nseiten) aseiten.replaceWith(nseiten); else aseiten.remove(); }
          self.mehrKnopfMachen();
          self._seite = seiteAus(url.search);
          self.standMerken();
          if (!self._wiederherstellen) {
            var fokus = erste ? erste.querySelector("h3 a") || erste.querySelector('a:not([tabindex="-1"])') : null;
            if (fokus) fokus.focus({ preventScroll: true });
          }
          return true;
        })
        .catch(function (e) {
          self.platzhalterWeg();
          knopf.removeAttribute("aria-busy");
          if (e && e.name === "AbortError") return false;
          self.fehler(true);
          return false;
        })
        .then(function (ok) { if (self.mehrCtrl === ctrl) self.mehrCtrl = null; return ok; });
    }

    /* Shopify lädt jeden Link auf /collections/… beim Antippen (Handy) bzw. Darüberfahren (Computer) per Speculation Rules
       als ganze Seite vor (Header «speculation-rules», gemessen ~64 KB je Klick auf «Mehr laden», die nie gebraucht werden).
       Ein Link lässt sich davon nicht ausnehmen: Mit Skript wird «Mehr laden» darum ein Knopf (data-href), ohne Skript bleibt
       der Link (Rückfall). Läuft nach jedem Einsetzen der Seiten-Navigation. */
    mehrKnopfMachen() {
      this.querySelectorAll("a[data-vfko-mehr][href]").forEach(function (a) {
        var b = doc.createElement("button");
        b.type = "button";
        b.className = a.className;
        b.setAttribute("data-vfko-mehr", "");
        b.setAttribute("data-href", a.getAttribute("href"));
        b.innerHTML = a.innerHTML;
        a.replaceWith(b);
      });
    }

    /* Platzhalter-Karten sofort beim Tippen auf «Mehr laden» (18.10.2026, gemessen: CLS 0,27–0,39 je Klick, wenn die Antwort
       länger als 0,5 s brauchte, weil Seitenzahlen und Fusszeile dann ohne frische Eingabe nach unten sprangen). Höhe = die
       der letzten echten Karte (gleiche Ansicht und Breite), Anzahl = so viele, wie kommen (data-vfko-rest/-pro-seite). */
    platzhalterSetzen(knopf) {
      var liste = this.querySelector("[data-vfko-karten]");
      var nav = knopf.closest("[data-vfko-seiten]");
      if (!liste || !nav) return;
      var n = platzhalterAnzahl(nav.getAttribute("data-vfko-rest"), nav.getAttribute("data-vfko-pro-seite"));
      /* Gemischte Suche: der Rest zählt Beiträge mit, wie viele Gerichte kommen, weiss niemand: höchstens eine Reihe */
      if (nav.hasAttribute("data-vfko-eine-reihe")) {
        var spalten = String(root.getComputedStyle(liste).gridTemplateColumns || "").split(" ").filter(Boolean).length || 1;
        n = Math.min(n, spalten);
      }
      var karten = liste.querySelectorAll(".vfko-karte:not(.vfko-karte--platzhalter)");
      var letzte = karten[karten.length - 1];
      var h = letzte ? Math.round(letzte.getBoundingClientRect().height) : 0;
      var frag = doc.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var li = doc.createElement("li");
        li.className = "vfko-karte vfko-karte--platzhalter";
        li.setAttribute("aria-hidden", "true");
        li.setAttribute("data-vfko-platzhalter", "");
        if (h > 0) li.style.height = h + "px";
        frag.appendChild(li);
      }
      liste.appendChild(frag);
    }

    platzhalterWeg() {
      this.querySelectorAll("[data-vfko-platzhalter]").forEach(function (li) { li.remove(); });
    }

    /* Stand «Mehr laden» merken (je Adresse): geladene Seite, die oberste Karte im Bild und ihr Abstand zum oberen Rand. Läuft nach jedem
       Anhängen und beim Verlassen der Seite (pagehide); während der Wiederherstellung bleibt die gemerkte Karte. */
    standMerken() {
      var schluessel = mehrSchluessel(root.location.pathname, root.location.search);
      if (!(this._seite > seiteAus(this._suche))) {
        /* nichts angehängt: einen alten Stand dieser Adresse vergessen, sonst holt ein späteres Neu laden ihn zurück (Prüffund) */
        this._stand = null;
        try { root.sessionStorage.removeItem(schluessel); } catch (e) { /* gesperrt */ }
        return;
      }
      var handle = "", oben = 0;
      if (this._wiederherstellen && this._stand) { handle = this._stand.handle; oben = this._stand.oben; }
      else {
        var kopf = this.querySelector(".vfko-leiste");
        var rand = kopf ? kopf.getBoundingClientRect().bottom : 0;
        var karten = this.querySelectorAll("[data-vfko-karten] > .vfko-karte:not(.vfko-karte--platzhalter)");
        for (var i = 0; i < karten.length; i++) {
          var r = karten[i].getBoundingClientRect();
          if (r.bottom <= rand + 1) continue;
          var k = karten[i].querySelector("[data-handle]");
          handle = k ? k.getAttribute("data-handle") : "";
          oben = Math.round(r.top);
          break;
        }
      }
      this._stand = { seite: this._seite, handle: handle, oben: oben };
      try { root.sessionStorage.setItem(schluessel, JSON.stringify(this._stand)); } catch (e) { /* privat/gesperrt: dann eben nicht */ }
    }

    /* Zurück ohne Back/Forward-Cache oder Neu laden: Seiten bis zur gemerkten wieder anhängen (gleicher Weg wie «Mehr laden»,
       mit Platzhaltern), danach zur gemerkten Karte scrollen. Greift der Back/Forward-Cache, läuft das Skript gar nicht neu. */
    standWiederherstellen() {
      var stand = null, nav = null;
      try { stand = JSON.parse(root.sessionStorage.getItem(mehrSchluessel(root.location.pathname, root.location.search)) || "null"); } catch (e) { stand = null; }
      try { nav = root.performance && root.performance.getEntriesByType ? root.performance.getEntriesByType("navigation")[0] : null; } catch (e) { nav = null; }
      var bis = wiederherstellenBis(stand, nav && nav.type, this._seite);
      /* Im Theme-Editor nie: dort lädt die Section bei jeder Änderung neu */
      if (!bis || this.ctrl || (root.Shopify && root.Shopify.designMode)) return;
      var self = this;
      this._wiederherstellen = true;
      this._stand = stand;
      if (root.history && "scrollRestoration" in root.history) root.history.scrollRestoration = "manual";
      var schritt = function () {
        var knopf = self.querySelector("[data-vfko-mehr]");
        if (self._seite >= bis || !knopf) return Promise.resolve(true);
        return self.mehrLaden(knopf).then(function (ok) { return ok ? schritt() : false; });
      };
      schritt().then(function (ok) {
        self._wiederherstellen = false;
        if (root.history && "scrollRestoration" in root.history) root.history.scrollRestoration = "auto";
        /* nur scrollen, wenn alles da ist und kein Filter-Ladevorgang dazwischenkam (Prüffund) */
        if (ok !== true || self.ctrl) return;
        var k = stand.handle ? self.querySelector('[data-vfko-karten] [data-handle="' + String(stand.handle).replace(/["\\]/g, "") + '"]') : null;
        var li = k ? k.closest(".vfko-karte") : null;
        if (!li) return;
        /* dieselbe Karte an dieselbe Stelle im Bild (oben = ihr Abstand zum oberen Rand beim Verlassen) */
        var oben = Number(stand.oben);
        if (!isFinite(oben)) oben = 0;
        root.scrollTo(0, Math.max(0, li.getBoundingClientRect().top + root.pageYOffset - oben));
      });
    }

    /* Einträge einer Liste der Antwort anhängen (nur neue Schlüssel). Fehlt die Liste hier (Suche: Seite 1 ohne Gerichte
       bzw. ohne Beiträge), kommt der ganze Block dazu: Karten samt Listenkopf vorne (statt des Leer-Hinweises), Beiträge vor
       den Seiten, Seiten vor der Seiten-Navigation. Gibt den ersten angehängten Eintrag zurück. */
    anhaengen(neu, sel, schluessel, art) {
      var nl = neu.querySelector(sel);
      if (!nl || !nl.children.length) return null;
      var al = this.querySelector(sel);
      if (!al) {
        var raster = this.querySelector("[data-vfko-raster]");
        var block = art ? nl.closest("[data-vfko-sonstige]") : nl;
        if (!raster || !block) return null;
        var leer = art ? null : raster.querySelector(".vfko-leer");
        if (leer) leer.remove();
        var nav = raster.querySelector("[data-vfko-seiten]");
        var vor = art ? (art === "artikel" && raster.querySelector('[data-vfko-sonstige="seiten"]')) || nav : raster.firstChild;
        var kopf = art ? null : neu.querySelector(".vfko-listenkopf");
        var titel = kopf ? kopf.previousElementSibling : null; /* unsichtbare h2 «Gerichte» (vf-kollektion-raster) */
        if (titel && titel.tagName === "H2") raster.insertBefore(titel, vor);
        if (kopf) raster.insertBefore(kopf, vor);
        ohneVorrang(block);
        raster.insertBefore(block, vor);
        return block.querySelector("li");
      }
      var alt = Array.prototype.map.call(al.children, schluessel);
      var kinder = Array.prototype.slice.call(nl.children);
      var plan = neuNachSchluessel(alt, kinder.map(schluessel));
      var erste = null;
      kinder.forEach(function (li, i) {
        if (!plan[i]) return;
        ohneVorrang(li);
        al.appendChild(li);
        erste = erste || li;
      });
      return erste;
    }

    /* «Alle 15 anzeigen» ↔ «Weniger anzeigen»; der Text zum Aufklappen steht in data-text-zu (Liquid). */
    mehrWerte(knopf) {
      var inhalt = knopf.closest("[data-vfko-gruppe]");
      if (!inhalt) return;
      var offen = knopf.getAttribute("aria-expanded") === "true";
      inhalt.querySelectorAll(".vfko-werte__mehr").forEach(function (li) { li.hidden = offen; });
      knopf.setAttribute("aria-expanded", offen ? "false" : "true");
      knopf.textContent = offen ? knopf.getAttribute("data-text-zu") : "Weniger anzeigen";
    }

    /* ---------- Beschreibung: per CSS auf drei Zeilen gekürzt (kein Springen), «Mehr lesen» nur, wenn sie länger ist ---------- */

    introPruefen() {
      var intro = this.querySelector("[data-vfko-intro]");
      if (!intro) return;
      var text = intro.querySelector(".vfko-intro__text"), knopf = intro.querySelector("[data-vfko-intro-mehr]");
      if (!text || !knopf) return;
      knopf.hidden = !(text.scrollHeight > text.clientHeight + 4);
    }

    introUmschalten(knopf) {
      var intro = knopf.closest("[data-vfko-intro]");
      var offen = intro.classList.toggle("is-offen");
      knopf.setAttribute("aria-expanded", offen ? "true" : "false");
      knopf.textContent = offen ? "Weniger" : "Mehr lesen";
    }

    /* ---------- Panels: Drawer «Alle Filter» (data-vfko-panel="drawer") und Nährwert-Feld (data-vfko-panel="naehrwerte") ---------- */

    panelOffen() { return this.querySelector("[data-vfko-panel].is-offen"); }

    panelOeffnen(name, ziel, knopf) {
      var panel = this.querySelector('[data-vfko-panel="' + name + '"]');
      if (!panel) return;
      var offen = this.panelOffen();
      if (offen && offen !== panel) this.panelSchliessen(true);
      this.oeffner = knopf || doc.activeElement;
      panel.classList.add("is-offen");
      doc.documentElement.classList.add("vfko-panel-offen");
      this.querySelectorAll('[data-vfko-oeffnen="' + name + '"]').forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
      /* Nährwert-Feld am Desktop unter seiner Pille (position:fixed, Werte aus dem Knopf) */
      var box = panelBox(panel);
      if (box && knopf && name !== "drawer") {
        var r = knopf.getBoundingClientRect();
        box.style.setProperty("--vfko-feld-top", Math.round(r.bottom + 8) + "px");
        box.style.setProperty("--vfko-feld-left", Math.round(Math.max(8, Math.min(r.left, root.innerWidth - box.offsetWidth - 8))) + "px");
      }
      var gruppe = ziel ? panel.querySelector('[data-vfko-details="' + ziel + '"]') : null;
      if (!gruppe && ziel) {
        var inhalt = panel.querySelector('[data-vfko-gruppe="' + ziel + '"]');
        gruppe = inhalt ? inhalt.closest("details") : null;
      }
      if (gruppe) {
        gruppe.open = true;
        var scroll = panel.querySelector(".vfko-drawer__inhalt");
        if (scroll) scroll.scrollTop = Math.max(0, gruppe.offsetTop - scroll.offsetTop - 8);
        var erstes = gruppe.querySelector("summary");
        if (erstes) erstes.focus({ preventScroll: true });
      } else if (box) {
        var zu = box.querySelector("[data-vfko-schliessen]");
        (zu || box).focus({ preventScroll: true });
      }
      this.fokusFalle();
    }

    panelSchliessen(ohneFokus) {
      var panel = this.panelOffen();
      if (!panel) return;
      panel.classList.remove("is-offen");
      doc.documentElement.classList.remove("vfko-panel-offen");
      var name = panel.getAttribute("data-vfko-panel");
      this.querySelectorAll('[data-vfko-oeffnen="' + name + '"]').forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      if (!ohneFokus && this.oeffner && this.oeffner.focus) this.oeffner.focus();
      if (!ohneFokus) this.oeffner = null;
    }

    /* Alle Stufen-Kästchen leeren (Knopf «Zurücksetzen» im Nährwert-Feld) */
    stufenLeeren() {
      this.querySelectorAll("[data-vfko-schieber]").forEach(function (box) {
        box.querySelectorAll("[data-vfko-stufe]").forEach(function (k) { k.checked = false; });
        schieberStandAusKaestchen(box);
      });
      this.laden(this.parameter(), { push: true });
    }

    fokusFalle() {
      if (this._falle) return;
      this._falle = true;
      var self = this;
      this.addEventListener("keydown", function (ev) {
        var panel = self.panelOffen();
        if (ev.key !== "Tab" || !panel) return;
        var box = panelBox(panel);
        var felder = Array.prototype.filter.call(box.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,summary,[tabindex="0"]'), function (el) { return el.offsetParent !== null && !el.closest("[inert]"); });
        if (!felder.length) return;
        var erstes = felder[0], letztes = felder[felder.length - 1];
        if (ev.shiftKey && (doc.activeElement === erstes || doc.activeElement === box)) { ev.preventDefault(); letztes.focus(); }
        else if (!ev.shiftKey && doc.activeElement === letztes) { ev.preventDefault(); erstes.focus(); }
      });
    }
  }

  root.customElements.define("vf-kollektion", VfKollektion);
})(typeof window !== "undefined" ? window : globalThis);
